import { Route } from 'react-router-dom';
import { HrHomePage } from '../modules/human-resources/HrHomePage';
import { HrSettingsPage } from '../modules/human-resources/HrSettingsPage';
import { OvertimePage } from '../modules/human-resources/OvertimePage';
import { ResultsPage } from '../modules/human-resources/ResultsPage';
import { EmuladorPage } from '../modules/human-resources/EmuladorPage';
import { RequireHrModule, RequireHrAdmin } from '../modules/human-resources/components/RequireHr';

/**
 * Registro de rutas de Gestion Humana - equivalente a router/routes.tsx
 * (Control Operativo) pero independiente: agregar una pantalla aqui NUNCA
 * toca el router de Control Operativo ni el Selector de Aplicacion.
 *
 * Devuelve un Fragment de <Route> (sin <Routes> propio) para anidarse dentro
 * del layout de Gestion Humana en el router raiz (ver App.tsx).
 *
 * FASE 2 (este entregable): "Horas Extra" ya es funcional (OvertimePage) -
 * reemplaza al placeholder <ComingSoonPage> de la Fase 1.
 */
export function GestionHumanaRoutes() {
  return (
    <>
      <Route path="/gestion-humana" element={<HrHomePage />} />
      <Route path="/gestion-humana/horas-extra" element={<RequireHrModule moduleId="overtime"><OvertimePage /></RequireHrModule>} />
      <Route path="/gestion-humana/resultados" element={<RequireHrModule moduleId="results"><ResultsPage /></RequireHrModule>} />
      <Route path="/gestion-humana/configuracion" element={<RequireHrAdmin><HrSettingsPage /></RequireHrAdmin>} />
      <Route path="/gestion-humana/emulador" element={<RequireHrAdmin><EmuladorPage /></RequireHrAdmin>} />
    </>
  );
}
